export default {
  RegularFund: 0, // kinh phí thường xuyên
  IrregularFund: 1, // kinh phí không thường xuyên
  ProjectFund: 2, // kinh phí dự án
};
